let fontScale = 1;

function setFontSizeScale() {
  // 1920对应44 - 1
  // 1366对应36 - 0.8181818181818181
  // 需要k使得k * ufs = fs
  // f(1920) = 1;
  // f(1366) = 0.8181818181818181;
  // f(x) = kx + b  ... (500 < x < 9999999)
  // k = (1 - 0.8181818181818181) / (1920 - 1366) = 0.0003281916639317362
  // b = 1 - 0.0003281916639317362 * 1920 = 0.36987200525106645

  function f(x: number) {
    return 0.0003281916639317362 * x + 0.36987200525106645;
  }

  const width = window.innerWidth;
  const ratio = f(width);
  document.documentElement.style.setProperty('--font-scale', '' + ratio);
  fontScale = ratio;
}

// 全局监听，设置css variable
window.addEventListener('resize', () => {
  setFontSizeScale();
});

window.addEventListener('load', () => {
  setFontSizeScale();
});

export function fontSize(size: number) {
  return size * fontScale;
}
